'use client';

import Script from 'next/script';

const COUNTERS = [101008137, 100957118];

export function YandexMetrika() {
  return (
    <>
      <Script
        id="yandex-metrika"
        strategy="lazyOnload"
        dangerouslySetInnerHTML={{
          __html: `
            (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
            m[i].l=1*new Date();
            for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
            k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
            (window, document, "script", "https://mc.yandex.ru/metrika/tag.js?id=${COUNTERS[1]}", "ym");

            ym(${COUNTERS[0]}, "init", {
              ssr:true,
              clickmap:true,
              trackLinks:true,
              accurateTrackBounce:true,
              webvisor:false,
              trackHash:true,
              childIframe:false,
              ecommerce:"dataLayer",
              referrer: document.referrer,
              url: location.href
            });

            ym(${COUNTERS[1]}, "init", {
              ssr:true,
              clickmap:true,
              trackLinks:true,
              accurateTrackBounce:true,
              webvisor:false,
              trackHash:true,
              childIframe:false,
              ecommerce:"dataLayer",
              referrer: document.referrer,
              url: location.href
            });
          `,
        }}
      />
      <noscript>
        <div>
          <img src="https://mc.yandex.ru/watch/101008137" style={{ position: 'absolute', left: '-9999px' }} alt="" />
          <img src="https://mc.yandex.ru/watch/100957118" style={{ position: 'absolute', left: '-9999px' }} alt="" />
        </div>
      </noscript>
    </>
  );
}
